import React from 'react';
import {Button, FormControlLabel, Typography, Box, Checkbox, Chip} from '@mui/material';
import * as ETVConstants from '../ETVConstants';

class ConnectFloorWithDisplays extends React.Component {

	constructor(props) {
      	super(props);
    }

    state = {
		deviceIDs:[],
		isLoaded:false,
		isLoading:false,
		originalDeviceIDs: [],
    }

	componentDidUpdate(prevProps) {
		if (prevProps.floor_id !== this.props.floor_id && !this.state.isLoading) {
			this.setState(
				{ deviceIDs: [], originalDeviceIDs: [], isLoaded: false },
				() => this.loadConnectedDisplays()
			);
		}
	}

    componentDidMount() {
		this.loadConnectedDisplays();
    }

    loadConnectedDisplays() {
		if (this.state.isLoading) return;
		this.setState({ isLoading: true });
		this.props.onStateChange?.({ hasChanges: false, isLoading: true });
		var accessToken = localStorage.getItem("etv.access_token");
      	var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/floor_access?action=get_connected_device_ids&floor_id="+this.props.floor_id;
		//console.log("url load all connected deviceIDs="+url);
	    fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            const list = result.list || [];
			this.setState({
				deviceIDs: list,
				originalDeviceIDs: list,
				isLoaded: true,
				isLoading: false,
			}, () => this.props.onStateChange?.({ hasChanges: false, isLoading: false }));
          },
          (error) => {
            this.setState({
              deviceIDs:[],
			  originalDeviceIDs: [],
              isLoaded: false,
              isLoading: false,
              error
            }, () => this.props.onStateChange?.({ hasChanges: false, isLoading: false }));
          }
        )
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

	hasChanges() {
		const { deviceIDs, originalDeviceIDs } = this.state;
		if (deviceIDs.length !== originalDeviceIDs.length) return true;
		const sortedA = [...deviceIDs].sort();
		const sortedB = [...originalDeviceIDs].sort();
		return !sortedA.every((val, i) => val === sortedB[i]);
	}

	saveConnectedDisplays = () => {
		this.props.onStateChange?.({ hasChanges: this.hasChanges(), isLoading: true });
		var accessToken = localStorage.getItem("etv.access_token");
      	var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/floor_access?action=set_connected_devices";
		url+="&floor_id="+this.props.floor_id;
		var deviceIDs = this.state.deviceIDs;
		for(var i=0; i<deviceIDs.length; i++) {
			url+="&device_id="+encodeURIComponent(deviceIDs[i]);
		}
		fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then((result) => {
			this.setState({ originalDeviceIDs: [...this.state.deviceIDs], isLoaded: true }, () => {
				this.props.onStateChange?.({ hasChanges: false, isLoading: false });
			});
		})
		.catch((error) => {
			this.props.onStateChange?.({ hasChanges: this.hasChanges(), isLoading: false });
			this.showInfoMessage("Error", "Failed to save floor");
		});
	};

	render() {
		const { all_devices } = this.props;
		const { deviceIDs, isLoaded } = this.state;

		if (!isLoaded) return null;

		const isChecked = (device_id) => deviceIDs.includes(device_id);

		const toggleDevice = (device_id) => {
			const updated = isChecked(device_id)
				? deviceIDs.filter(id => id !== device_id)
				: [...deviceIDs, device_id];
			this.setState({ deviceIDs: updated }, () => this.props.onStateChange?.({ hasChanges: this.hasChanges(), isLoading: false }));
		};

		const selectAll = () => {
			const allIDs = all_devices.map(dev => dev.device_id);
			this.setState({ deviceIDs: allIDs }, () => this.props.onStateChange?.({ hasChanges: this.hasChanges(), isLoading: false }));
		};

		const deselectAll = () => {
			this.setState({ deviceIDs: [] }, () => this.props.onStateChange?.({ hasChanges: this.hasChanges(), isLoading: false }));
		};

		return (
			<Box>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
					<Box>
						<Typography variant="h5" fontWeight={700}>
							Floor {this.props.floor_label}
						</Typography>
					</Box>
					<Chip color="primary" variant="outlined" label={`${deviceIDs.length} selected`} />
				</Box>

				<Box display="flex" gap={1} mb={2}>
					<Button variant="outlined" onClick={selectAll}>
						{ETVConstants.trans("select_all")}
					</Button>
					<Button variant="outlined" onClick={deselectAll}>
						{ETVConstants.trans("deselect_all")}
					</Button>
				</Box>

				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
						gap: 1,
					}}
				>
					{[...all_devices]
						.sort((a, b) => String(a.device_name || '').localeCompare(String(b.device_name || '')))
						.map((device) => (
						<FormControlLabel
							key={device.device_id}
							control={
								<Checkbox
									checked={isChecked(device.device_id)}
									onChange={() => toggleDevice(device.device_id)}
								/>
							}
							label={device.device_name}
							sx={{
								m: 0,
								px: 1.25,
								py: 0.5,
								border: 1,
								borderColor: isChecked(device.device_id) ? 'primary.main' : 'divider',
								bgcolor: isChecked(device.device_id) ? 'action.selected' : 'background.paper',
								borderRadius: 1.5,
							}}
						/>
					))}
				</Box>
			</Box>
		);
	}

}

export default ConnectFloorWithDisplays;
